import React from 'react';
import { FullLogoDark, FullLogoLight } from 'shared/assets/icons';
import { useBrowserPrefersDarkMode } from 'shared/lib/mui';

import * as Styled from './login-logo.style';

export const LoginLogo: React.FC = () => {
  const prefersDarkMode = useBrowserPrefersDarkMode();

  return (
    <Styled.Content>
      {prefersDarkMode ? (
        <FullLogoDark height="28" width="100" />
      ) : (
        <FullLogoLight height="28" width="100" />
      )}
    </Styled.Content>
  );
};
